/**
 * MY — Allotment of Shares (Bonus Issue, M32203) Register Detail 매핑.
 *
 * TASK_DATA.formData (PreSetBonusIssuePanel.handleCreateTask):
 *   {
 *     entityCd, transactionDate,
 *     shareholders: [{ shareholder, shareholderName, currencies:[{ currency, shareClasses:[{ classOfShares, numberOfShares, ... }] }] }],
 *     presetForm: { companyName, sharePrice, allottees:[{allottee_name, allottee_shares, ...}], ... }
 *   }
 *   → Cash(M32200)/OTC(M32202) 와 동일 shareholders 포맷. Register = entity_my/shares INSERT.
 */
import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

registerRegisterDetail('M32203', {
  title: 'Allotment of Shares (Bonus) Details',
  repeatArrayPath: 'shareholders',
  fields: [
    { label: 'Company Name', key: ['entityName', 'companyName', 'company_name', 'presetForm.companyName'] },
    { label: 'Registration No.', key: ['entityRegNo', 'companyRegistrationNo', 'presetForm.companyRegistrationNo'] },
    { label: 'Share Price (RM)', key: ['presetForm.sharePrice', 'sharePrice', 'share_price'] },
    { label: 'Allotment Date', key: ['presetForm.state.values.allotment_date', 'allotment_date', 'transactionDate'] },
    // Allottee(= shareholder) 행별 — Register 버튼 시 배정자·증자 주식수 미리보기
    { label: 'Allottee', key: ['shareholders.0.shareholderName'] },
    { label: 'Class', key: ['shareholders.0.currencies.0.shareClasses.0.classOfShares'] },
    { label: 'Shares to Allot', key: ['shareholders.0.currencies.0.shareClasses.0.numberOfShares'] },
    { label: 'Amount (RM)', key: ['shareholders.0.currencies.0.shareClasses.0.issuedShareCapital'] },
  ],
});
